module.exports = __webpack_public_path__ + "img/253.f123eaac.png";